<template src="./template.html" ></template>

<script>
// @ is an alias to /src
// import myAxios from '../../functions/myAxios'
import MyAlert from '../../components/alert/MyAlert.vue'
import MyListTable from './table.vue'
import MyListButtons from '../add/Buttons.vue'
import MyComment from '../../components/MyComment.vue'
const menus = require('../../../../menus.json');
const menu_subs = menus.items.map(i => i.subs).flat();
// menu_subs.pop() //remove 'exit' from permissions
//
export default {
  name: 'roleItems',
  methods: {
    async onSave() {
      //
      let _method = 'POST'
      if (this.formState === 'edit') {
        _method = 'PUT'
      }
      this.$refs.form.validate()
      let _data = {
        method: _method,
        url: `/api/${this.route}`,
        data: {
          data: this.model
        },
      }
      if (this.valid) {
        await this.$store.dispatch('save', _data)
        let res = this.$store.getters.saveData
        // console.log(res);
        if (res && (res.insert || res.update)) {
          this.alert = true
        }
      }
    },
    otherAll(checked, permission) {
      this.model.permissions.forEach((row) => {
        if (checked && !row.values.includes(permission) && row.system.includes(permission)) {
          row.values.push(permission)
        }
        if (!checked && row.values.includes(permission) && row.name !== 'exit') {
          var index = row.values.indexOf(permission);
          if (index !== -1) row.values.splice(index, 1);
        }
      })
    },
  },
  async beforeCreate() {
    this.formState = this.$router.currentRoute.path.split("/")[2]
    this.route = this.$store.getters.pageInfo.route
    this.headers = this.$store.getters.pageInfo.columns
    //
    // console.log(this.formState);
    if (this.formState === 'edit') {
      let _mid = this.$router.currentRoute.path.split("/")[3]
      let data = {
        url: `/api/${this.route}`,
        params: {
          mid: _mid
        },
      }
      await this.$store.dispatch('getInfo', data)
      this.model = this.$store.getters.editData
      this.model.permissions.forEach((row) => {
        menu_subs.forEach((menu) => {
          if (row.name === menu.name) {
            row.title = menu.title
            row.system = menu.permissions
          }
        })
      })
      // console.log(JSON.stringify(this.model.permissions[0]));
    }
  },
  async created() {
    if (this.formState === 'add') {
      this.model.permissions = menu_subs.map(e => ({
        name: e.name,
        title: e.title,
        values: [],
        system: e.permissions
        // ...e => other elements
      }))
      // console.log(JSON.stringify(this.model.system[0]));
    }
    this.model.permissions[0].values = ['show']
  },
  watch: {
    model: {
      handler(newValue) { //, oldValue
        // console.log(newValue);
        let systems = newValue.permissions.map(i => i.system).flat()
        let values = newValue.permissions.map(i => i.values).flat()
        const countSystems = systems.reduce((acc, curr) => (acc[curr] = (acc[curr] || 0) + 1, acc), {});
        const countValues = values.reduce((acc, curr) => (acc[curr] = (acc[curr] || 0) + 1, acc), {});
        countValues.show < countSystems.show ? this.show.indeterminate = true : this.show.indeterminate = false
        countValues.add < countSystems.add ? this.add.indeterminate = true : this.add.indeterminate = false
        countValues.edit < countSystems.edit ? this.edit.indeterminate = true : this.edit.indeterminate = false
        countValues.remove < countSystems.remove ? this.remove.indeterminate = true : this.remove.indeterminate = false
        countValues.print < countSystems.print ? this.print.indeterminate = true : this.print.indeterminate = false
        countValues.telegram < countSystems.telegram ? this.telegram.indeterminate = true : this.telegram.indeterminate = false
      },
      deep: true
    }
  },
  data: () => ({
    valid: false,
    alert: false,
    loading: false,
    all: {
      checked: false,
      indeterminate: false
    },
    show: {
      checked: false,
      indeterminate: false
    },
    add: {
      checked: false,
      indeterminate: false
    },
    edit: {
      checked: false,
      indeterminate: false
    },
    remove: {
      checked: false,
      indeterminate: false
    },
    print: {
      checked: false,
      indeterminate: false
    },
    telegram: {
      checked: false,
      indeterminate: false
    },
    model: {
      title: null,
      permissions: []
    },
    rules: {
      required: value => !!value || 'اجباری',
      min: v => v && v.length >= 6 || 'حداقل 6 کاراکتر',
    },
  }),
  props: ['formTitle'],
  components: {
    MyAlert,
    MyComment,
    MyListTable,
    MyListButtons,
  },
}
</script>
